import Article from './Article';

export const articleRoutes = [{path: '/articles/:id', name: 'Article', Component: Article}];
